import Popover from 'react-bootstrap/lib/Popover'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Info from 'react-icons/lib/fa/info-circle'

const popoverRight = (text) => (
  <Popover id="popover-positioned-right">
    {text}
  </Popover>
);

const InfoPopOver = (props) => (
  <div className='popover-container'>
    <OverlayTrigger trigger="click" rootClose placement="right" overlay={popoverRight(props.popOverText)}>
      <a href="#" onClick={e => {e.preventDefault();}}><Info /></a>
    </OverlayTrigger>
  </div>
)

export default InfoPopOver;
